function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["responsive"],
  _excluded2 = ["slides"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var calcWidthsMinMax = function calcWidthsMinMax(_ref) {
  var minSlideWidth = _ref.minSlideWidth,
    maxSlideWidth = _ref.maxSlideWidth,
    gutter = _ref.gutter,
    width = _ref.width;
  if (minSlideWidth > maxSlideWidth) {
    throw new Error('minSlideWidth cannot be greater maxSlideWidth');
  }
  var containerToSlideRatio = width / (minSlideWidth + gutter);
  var possibleSlides = Math.floor(containerToSlideRatio);
  var slideWidth = Math.min(width / possibleSlides, maxSlideWidth + gutter);
  return {
    containerWidth: width,
    slideWidth: slideWidth,
    maskWidth: possibleSlides === 0 ? minSlideWidth : possibleSlides * slideWidth
  };
};
var calcWidthsNumSlides = function calcWidthsNumSlides(_ref2) {
  var slides = _ref2.slides,
    width = _ref2.width;
  var slideWidth = Math.floor(width / slides);
  return {
    containerWidth: width,
    slideWidth: slideWidth,
    maskWidth: width
  };
};
var getNewWidths = function getNewWidths(_ref3, containerRef) {
  var responsive = _ref3.responsive,
    props = _objectWithoutProperties(_ref3, _excluded);
  var _containerRef$current = containerRef.current.getBoundingClientRect(),
    width = _containerRef$current.width;
  var _responsive = responsive({
      width: width
    }),
    slides = _responsive.slides,
    responsiveResult = _objectWithoutProperties(_responsive, _excluded2);
  if (!slides) {
    return calcWidthsMinMax(_objectSpread(_objectSpread(_objectSpread({}, props), responsiveResult), {}, {
      width: width
    }));
  }
  return calcWidthsNumSlides({
    slides: slides,
    width: width
  });
};
export default getNewWidths;